import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Button, Typography } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { ClearIconButtonProps as Props } from './types';

export const ClearIconButton = memo(({ className, onClick, count }: Props) => {
  return (
    <Button
      className={classnames('ClearIconButton', className)}
      sx={SX.root}
      variant="outlined"
      color="default"
      size="xsmall"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      disableRipple
      disableFocusRipple
      disableTouchRipple
    >
      <Icon name="delete" size={16} color="error.400" />
      <Typography sx={{ pr: 0.5 }} variant="body5">
        {count}
      </Typography>
    </Button>
  );
});

ClearIconButton.displayName = 'ClearIconButton';
